import { SVGProps } from 'react';

export const CrossIcon = ({ ...rest }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M16.7226 6.21927C17.0154 5.9267 17.4903 5.92672 17.7831 6.21927C18.0759 6.51208 18.0758 6.98692 17.7831 7.27981L13.0614 12.0005L17.7831 16.7222L17.8339 16.7788C18.0743 17.0733 18.0575 17.5081 17.7831 17.7827C17.5085 18.0572 17.0738 18.0739 16.7792 17.8335L16.7226 17.7827L12.0009 13.0611L7.28019 17.7827L7.22355 17.8335C6.92904 18.0738 6.49429 18.0572 6.21965 17.7827C5.94535 17.5082 5.92781 17.0733 6.16789 16.7788L6.21965 16.7222L10.9403 12.0005L6.21965 7.27981C5.92698 6.9869 5.92682 6.51208 6.21965 6.21927C6.51249 5.92677 6.98738 5.92671 7.28019 6.21927L12.0009 10.94L16.7226 6.21927Z"
        fill="#1A1919"
      />
    </svg>
  );
};
